import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import auth from './modules/auth'
import condition from './modules/condition'
import solarhome from './modules/solarhome'
import createLogger from '../plugins/logger'

Vue.use(Vuex)

const state = {
  toastVisible: false,
  toastMessage: '',
  toastState: false,
  reportData: {},
  noticeList: [],
  basicMenuList: {
    serviceList: [],
    mobileServiceList: []
  }
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    auth,
    condition,
    solarhome
  },
  plugins: process.env.NODE_ENV !== 'production'
    ? [createLogger()]
    : []
})



// WEBPACK FOOTER //
// ./src/store/index.js